"use client"
import { useState } from "react"
import "./CareersMean.css"

const CareersMean = () => {
  const [activeTab, setActiveTab] = useState("impact")

  const tabs = [
    { id: "belong", label: "Join a company where you belong" },
    { id: "purpose", label: "Shared purpose" },
    { id: "impact", label: "Make an impact with us" },
  ]

  const tabContent = {
    belong: {
      title: "JOIN A COMPANY WHERE YOU BELONG",
      icon: "/join.webp",
      description:
        "Want to be surrounded by genuine mutual respect, positive energy, and empowering opportunities? Here we believe careers should be rewarding and fulfilling. And we want you to succeed so we promote teamwork and support each other's success. That's why we're building a company where people are rewarded for their work and have fun.",
    },
    purpose: {
      title: "SHARED PURPOSE",
      icon: "/shared.svg",
      description:
        "Imaginary Cloud is a place where learning is never over. We want you to be successful and confident in your career to focus on what matters most. But be prepared to be challenged every day. And we're always looking for ways to improve and we strive to make seamless technology.",
    },
    impact: {
      title: "MAKE AN IMPACT WITH US",
      icon: "/impact.webp",
      description:
        "You'll be part of a team dedicated to making the world a better place through technology. You'll have an impact by developing and delivering innovative technology and solutions so that people can focus on what matters most.",
    },
  }

  return (
    <section className="careers-mean-section8723">
      <div className="container">

      <div className="title-row8723">
        <h2>
          WHAT DOES IT MEAN TO BE <br />
          <span>HUMAN-CENTRIC</span>
        </h2>
        
      </div>

      <div className="tab-card8723">
        <div className="tabs8723">
          {tabs.map((tab) => (
            <div
              key={tab.id}
              className={`tab ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </div>
          ))}
        </div>

        <div className="tab-content8723">
          <img src={tabContent[activeTab].icon} alt="icon" />
          <h3>{tabContent[activeTab].title}</h3>
          <p>{tabContent[activeTab].description}</p>
        </div>
      </div>
      </div>
      
    </section>
  )
}

export default CareersMean
